export default "__VITE_ASSET__DPhVnMxY__"